<template>
    <div class="card" v-if="learners">

        <div class="card-header">
            <div class="row">
                <div class="col">
                    <h3 class="mb-0 text-uppercase">
                        {{ registration.cohort.name }}
                    </h3>
                </div>
            </div>
        </div>

        <p class="card-body mb-0 text-sm" v-if="empty">{{ $t('dashboard.no-learner') }}</p>

        <div class="pt-3" v-if="!empty">
            
            <table-control :paging="paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="filteredLearners">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <a href="#" class="avatar rounded-circle" :class="{'disabled': isWithdrawed(row)}"
                                @click.prevent="openLearner(row)">
                            <img :src="row.avatar">
                        </a>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">
                        <div :class="{'disabled': isWithdrawed(row)}">
                            <h4 class="mb-0">
                                <a href="#" @click.prevent="openLearner(row)">
                                    {{row.name}}
                                </a>
                            </h4>
                            <small v-if="row.owner">
                                {{ row.owner.name }}
                            </small>
                            <small v-if="row.entity">
                                / {{ row.entity.name }}
                            </small>
                        </div>
                    </template>
                </el-table-column>
                
                <!--
                <el-table-column>
                    <template v-slot="{row}">

                        <base-progress type="info" :value="progress(row)">
                        </base-progress>

                        <span class="d-block">
                            <strong>{{ progress(row) }}%</strong> {{ $t('dashboard.done').toLowerCase() }}
                            <span v-if="row.state.remedial_sessions">
                                + <strong>{{ row.state.remedial_sessions }}</strong> {{ $t('dashboard.remedial-s').toLowerCase() }}
                            </span>
                        </span>

                        <small class="d-block mt-1" v-if="row.state.meta && row.state.meta.go_ground">
                            <i class="fas fa-plane-departure mr-1"></i>
                            {{ $t('degrees.go-ground') }}
                        </small>

                    </template>
                </el-table-column>
                -->

                <el-table-column align="right" class-name="actions" width="130">
                    <template v-slot="{row}">
                        <div class="p-1">

                            <base-button type="primary" size="sm" class="d-inline-block mb-1 mr-0" @click="openResults(row)"
                                :disabled="learner && learner.id == row.id"
                            >
                                <i class="tim-icons icon-line-chart mr-1"></i> {{ $t('reports.cohort-results') }}
                            </base-button>

                            <!--
                            <base-button type="secondary" size="sm" class="d-inline-block mb-1 mr-0" @click="openLearner(row)">
                                {{ $t('dashboard.follow-up') }}
                            </base-button>
                            -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <table-pagination :paging="paging"></table-pagination>                
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            registration: {
                type: Object,
            },

            learners: {
                type: Array,
            },

            learner: {
                type: Object,
            },
        },

        data() {
            return {
                paging: {
                    currentPage: 1,
                    perPage: 10,
                    total: 0
                },
                search: '',
            }
        },

        computed: {

            empty() {
                return this.learners.length == 0 && !this.search
            },

            filteredLearners() {
                // Search filter.
                let learners = this.learners.filter(learner => !this.search
                    || learner.name.toLowerCase().includes(this.search.toLowerCase())
                )
                // Sorting.
                learners = learners.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)

                // Paging.
                this.paging.total = learners.length
                return learners.slice((this.paging.currentPage - 1) * this.paging.perPage, this.paging.currentPage * this.paging.perPage)
            },
        },

        methods: {     

            isWithdrawed(row) {
                return !row.pivot.active
            },

            progress(learner) {
                if (learner.state.empty || learner.state.sessions_count == 0) {
                    return 0
                }
                let progress = (learner.state.completed_sessions ? learner.state.completed_sessions : 0) * 100 / learner.state.sessions_count
                return parseInt(progress)
            },

            openLearner(learner) {
                this.$router.push({ name: 'dashboard-learner-registration',
                    params: {
                        learnerId: learner.id,
                        registrationId: this.registration.id
                    }
                })
            },
            
            openResults(learner) {
                this.$router.push({
                    name: 'report-learner-registration-results',
                    params: {
                        learnerId: learner.id,
                        registrationId: this.registration.id
                    }
                })
            },
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
        padding-left: 0;
    }
    .card >>> .table-control form {
        width: 100%;
    }
    .disabled, .disabled h4 {
        color: #bbb !important;
    }
    .disabled img {
        opacity: 0.5;
    }

</style>
